// tokens.ts - Hop Resto design tokens (port of _maquette/app/tokens.jsx).
// Art direction (spec §14): GREEN is RESERVED for availability and is never used
// for anything else. CORAL is the brand/action color. Both rules are enforced
// throughout the design system.
import type { CSSProperties } from "react";

/**
 * Palette de base. Le vert ne sert QU'À la disponibilité ; le corail est la
 * couleur de marque / d'action.
 */
export const HR = {
  green: "#2E9E5B", // disponibilité - NEVER anything else
  greenDeep: "#247E48",
  greenSoft: "#E7F3EC",
  cream: "#FAF6F0", // fond
  surface: "#FFFFFF",
  ink: "#2D2A26", // texte principal (jamais noir pur)
  inkSoft: "#7A746C", // texte secondaire
  muted: "#C9C3BB", // restos sans dispo / pins grisés
  hairline: "#ECE6DE",
  red: "#D03B2F", // erreur / Complet
  coral: "#E2654F", // marque / actions
  coralDark: "#C44A36",
} as const;

/** "#RRGGBB" + alpha -> "rgba(r,g,b,a)". */
export function hexA(hex: string, alpha: number): string {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

/**
 * Variables CSS appliquées à la racine de chaque surface.
 * Version statique (non-tweakable) du `themeVars` de la maquette : le corail est
 * fixe et le paramètre de tweaks live a été retiré.
 */
export function themeVars(): CSSProperties {
  return {
    "--coral": HR.coral,
    "--coral-dark": HR.coralDark,
    "--coral-tint": hexA(HR.coral, 0.1),
    "--green": HR.green,
    "--green-deep": HR.greenDeep,
    "--green-soft": HR.greenSoft,
    "--cream": HR.cream,
    "--surface": HR.surface,
    "--ink": HR.ink,
    "--ink-soft": HR.inkSoft,
    "--muted": HR.muted,
    "--hairline": HR.hairline,
    "--red": HR.red,
    "--font": "Nunito, system-ui, sans-serif",
    fontFamily: "Nunito, system-ui, sans-serif",
    color: HR.ink,
  } as CSSProperties;
}
